
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faXmark as farXmark,
    } from '@fortawesome/pro-regular-svg-icons/faXmark';

    import {
        faPhotoFilm as farPhotoFilm,
    } from '@fortawesome/pro-regular-svg-icons/faPhotoFilm';

    import { shuffleList } from '@/utils/helpers';
    import CompanyCarousel from '@/components/Company/CompanyCarousel';

    export default {
        name: 'CompanyCarouselLightbox',

        components: {
            CompanyCarousel,
            FontAwesomeIcon,
        },

        props: {
            media: {
                type: Array,
                required: true,
            },

            company: {
                type: String,
                required: true,
            },

            height: {
                type: Number,
                default: 0,
            },

            width: {
                type: Number,
                default: 361,
            },
        },

        data() {
            return {
                isExpand: false,
                shuffledMedia: [],
                icons: {
                    farXmark,
                    farPhotoFilm,
                },
            };
        },

        beforeDestroy() {
            this.closeLightBox();
        },

        mounted() {
            this.lightboxEl = this.$refs.lightbox;
            this.shuffleMedia();
        },

        methods: {
            shuffleMedia() {
                this.shuffledMedia = shuffleList([...this.media]);
            },

            handleExpand() {
                this.isExpand = true;
                document.body.append(this.lightboxEl);
                document.body.classList.add('overflow-hidden');
            },

            closeLightBox() {
                this.isExpand = false;
                document.body.classList.remove('overflow-hidden');
                this.lightboxEl.remove();
            },
        },
    };
